export default "__VITE_ASSET__D3Piyl4V__"